import * as Keychain from 'react-native-keychain';

const TOKEN_KEY = 'tailorapp_tokens';

export const secureStorage = {
  saveTokens: async (accessToken, refreshToken) => {
    await Keychain.setGenericPassword(
      TOKEN_KEY,
      JSON.stringify({accessToken, refreshToken}),
    );
  },

  getTokens: async () => {
    const credentials = await Keychain.getGenericPassword();
    if (credentials) {
      return JSON.parse(credentials.password);
    }
    return null;
  },

  clearTokens: async () => {
    await Keychain.resetGenericPassword();
  },
};
